/* 🔒 The notes list's composer (decision 0910): on a phone the box takes the whole
   row and Add sits beneath it at the right; from the md breakpoint Add stands at
   the box's right, top-aligned so a grown box does not pull it down the row. */
.composer {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--space-2);
  width: 100%;
}

/* 🔒 Decision 7290: the Rich text switch stands over the box, as the note window draws it. */
.richSwitch {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.richLabel {
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-semibold);
  color: var(--text);
}

.row {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--space-2);
}

.box {
  flex: 1 1 auto;
  min-width: 0;
}

.add {
  display: inline-flex;
  flex: none;
  align-self: flex-end;
}

@media (--bp-md) {
  .row {
    flex-direction: row;
    align-items: flex-start;
  }

  .add {
    align-self: flex-start;
  }
}
